import styled, { css } from 'styled-components'

export const Subtitle = styled.div<{ $required?: boolean }>`
  color: #757575;
  font-size: 14px;
  font-weight: 700;
  padding: 16px 0 4px;
  svg {
    position: absolute;
    margin-top: 4px;
    margin-left: 15px;
    width: 12px;
  }
  ${(props) =>
    props.$required &&
    css`
      &::after {
        content: ' *';
        color: #f5222d;
      }
    `}
`

export const Actions = styled.div`
  text-align: right;
  padding-top: 16px;
  button {
    margin: 0;
    margin-left: 8px;
    border-radius: 8px;
    padding: 12px;
  }
`
